import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  classesPath,
  clearErrorMessage,
  clearSuccessMessage,
  Context,
  createClass,
  CREATE_CLASS_SUCCESS_MESSAGE,
  fetchTeachers,
  IClassParam,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import Toast from "../../../molecules/Toast";
import ClassForm from "../../../templates/manager/ClassForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();

  React.useEffect(() => {
    if (state.success_message === CREATE_CLASS_SUCCESS_MESSAGE) {
      Toast.success(state.success_message);
      dispatch(clearSuccessMessage());
      history.push(classesPath);
    }
  }, [history, dispatch, state.success_message]);

  const createClassFunc = React.useCallback(
    (cls: IClassParam) => {
      dispatch(peep(createClass(cls)));
    },
    [dispatch, peep],
  );

  React.useEffect(() => {
    dispatch(fetchTeachers());
    return () => dispatch(clearErrorMessage());
  }, [dispatch]);

  return (
    <div>
      <Breadcrumb
        links={[{ title: titles.classes, to: classesPath }]}
        currentTitle={titles.newClass}
      />
      <ClassForm
        title={titles.newClass}
        calling={calling}
        teacher_ids={[]}
        teachers={state.teachers}
        error={state.error}
        isNextYear={false}
        upsertClass={createClassFunc}
      />
    </div>
  );
};
